import cn from "clsx";
import type { DecisionGraph } from "@imminently/decisively-core";
import { type VisibleMask, neighbourPaths } from "../../GraphVisualisation/decisionGraphView";
import type React from "react";

import stl from "./DebuggerGraphNode.module.scss";

interface GraphNodeCountEarProps {
  /** The view's DecisionGraph (a decision flow's: its release's rule graph). */
  graph: DecisionGraph | null;
  /** The ids in the view (null or undefined for all of them). */
  visible?: VisibleMask;
  currNodeId: string;
  isTargetNode: boolean;
  isDragging?: boolean;
  visibleNodeIds: string[] | null;
  addVisibleNodes: (nodeIds: string[]) => void;
  showHidden?: boolean;
}

const GraphNodeCountEar = (props: GraphNodeCountEarProps) => {
  const {
    graph,
    visible,
    currNodeId,
    isTargetNode,
    visibleNodeIds, // if null then no restrictions are being applied, and we can assume the graph is fully expanded
    addVisibleNodes,
    showHidden = true,
    isDragging,
  } = props;
  const neighbours = (direction: "predecessors" | "successors"): string[] =>
    !graph ? [] : neighbourPaths(graph, visible, currNodeId, direction, { skipHidden: !showHidden });
  const predecessors = neighbours("predecessors");
  const successors = neighbours("successors");

  const predecessorsExpanded = (() => {
    // if (!visibleNodeIds) {
    //   return false;
    // }
    if (0 === predecessors?.length || visibleNodeIds === null) {
      return true;
    }
    return predecessors.every((nodeId) => (visibleNodeIds || []).includes(nodeId));
  })();
  const successorsExpanded = (() => {
    // if (!visibleNodeIds) {
    //   return false;
    // }
    if (0 === successors?.length || visibleNodeIds === null) {
      return true;
    }
    return successors.every((nodeId) => (visibleNodeIds || []).includes(nodeId));
  })();

  const successorsNotClickable = 0 === (successors?.length || 0) || successorsExpanded;
  const predecessorsNotClickable = 0 === (predecessors?.length || 0) || predecessorsExpanded;

  // -- handlers

  const onClickExpandSuccessors = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (!successorsExpanded && successors?.length) {
      addVisibleNodes(successors);
    }
  };

  const onClickExpandPredecessors = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (!predecessorsExpanded && predecessors?.length) {
      addVisibleNodes(predecessors);
    }
  };

  // -- rendering

  return (
    <div
      id={`graph_ignoreclick_ear_${currNodeId}`}
      className={cn(stl.count_ear, { [stl.target_node]: isTargetNode }, { [stl.dragging]: isDragging })}
    >
      <div
        className={cn(
          stl.row,
          stl.upper,
          { [stl.expanded]: predecessorsExpanded },
          { [stl.not_clickable]: predecessorsNotClickable },
        )}
        onClick={onClickExpandPredecessors}
      >
        {predecessors?.length || "-"}
      </div>
      <div
        className={cn(
          stl.row,
          stl.lower,
          { [stl.expanded]: successorsExpanded || 0 === successors?.length },
          { [stl.not_clickable]: successorsNotClickable },
        )}
        onClick={onClickExpandSuccessors}
      >
        {successors?.length || "-"}
      </div>
    </div>
  );
};

export default GraphNodeCountEar;
